"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onReady = exports.viewerConnector = void 0;
const server_1 = require("./server");
const viewerConnector = (options = {}) => {
    return (bot) => (0, server_1.createMineflayerPluginServer)(bot, options);
};
exports.viewerConnector = viewerConnector;
const onReady = (bot) => {
    if (bot.webViewer)
        return Promise.resolve();
    return new Promise((resolve) => {
        bot.once('inject_allowed', () => {
            resolve();
        });
    });
};
exports.onReady = onReady;
